import { create } from 'zustand'
import * as llmApi from '@/api/llmConfig'
import type { LLMConfigItem } from '@/api/llmConfig'

interface LLMState {
  /** 当前激活的配置 */
  activeConfig: LLMConfigItem | null
  /** 是否已加载 */
  loaded: boolean
  /** 是否正在加载 */
  loading: boolean

  /** 获取激活的配置 */
  fetchActiveConfig: () => Promise<void>
  /** 设置激活配置（供页面直接注入） */
  setActiveConfig: (config: LLMConfigItem | null) => void
}

/**
 * AI 配置全局 Store
 * 供所有 AI 功能模块获取当前配置
 */
export const useLLMStore = create<LLMState>()((set) => ({
  activeConfig: null,
  loaded: false,
  loading: false,

  fetchActiveConfig: async () => {
    set({ loading: true })
    try {
      const res = await llmApi.getActiveConfig()
      set({ activeConfig: res, loaded: true })
    } catch {
      set({ activeConfig: null, loaded: true })
    } finally {
      set({ loading: false })
    }
  },

  setActiveConfig: (config) => set({ activeConfig: config, loaded: true }),
}))
